import PortalIdParser from 'PortalIdParser';
export const getRootUrl = () => `/live-messages/${PortalIdParser.get()}`;